import { CLASS_NAME_PREFIX } from "../__config__/constants";

export const SliderClassName = `${CLASS_NAME_PREFIX}-slider`;
export const SliderFocusVisibleClassName = `${SliderClassName}__focus-visible`;
